import { useRef, useState, useEffect } from "react";
import styled from "styled-components";

import { ErrorMessage, Form, Formik } from "formik";
import CustomFormSaveButton from "./CustomFormSaveButton";
import { MdFileCopy } from "react-icons/md";
import cx from "classnames";
import { scrollToTop } from "oautils/oaCommonUtils";
import WebApi from "api/ApiConstants";
import React from "react";
import CustomReactTable from "./CustomReactTable";
import { Button } from "@material-ui/core";
import { MdSave } from "react-icons/md";

const FlightMarkupTable = (props) => {
  const formikRef = useRef();
  const [replicateValue, setReplicateValue] = useState(0);
  const [replicatingValues, setReplicatingValues] = useState(false);
  const [replicateLabel, setReplicateLabel] = useState("Replicate");

  const columns = [
    {
      header: "Code",
      accessorKey: "carrier",
      filterable: true,
      cell: (props) => (
        <div style={{ verticalAlign: "middle" }}>{props.row.carrier}</div>
      ),
      // size: 83,
    },
    {
      header: "Airline",
      accessorKey: "airline",
      filterable: true,
      // size: 200,
    },
    {
      header: "Supplier",
      accessorKey: "supplier",
      // size: 150,
    },
    {
      header: "Fare Type",
      accessorKey: "fareType",
      // size: 250,
    },
    {
      header: "Markup Type",
      accessorKey: "markupType",
      // size: 150,
    },
    {
      header: "Amount (₹)",
      accessorKey: "markupAmount",
      enableColumnFilter: false,
      flexGrow: 1,
      cell: (props) => (
        <div>
          <input
            className="markup-input-field"
            name={props.row._original.formFieldName}
            placeholder={props.row.markupAmount}
            value={
              formikRef.current &&
              formikRef.current?.values?.[props?.row?._original?.formFieldName]
            }
            onChange={(e) =>
              onChangeMarkup(e, props?.row?._original?.formFieldName)
            }
          />
        </div>
      ),
    },
  ];

  function onChangeMarkup(e, fieldName) {
    if (formikRef.current) {
      formikRef.current.setFieldValue(fieldName, e.target.value);
    }
  }

  function replicateMarkupValues() {
    if (formikRef.current) {
      setReplicatingValues(true);
      setReplicateLabel("Replicating ...");
  
      const updatedValues = { ...formikRef.current.values };
      Object.keys(updatedValues).forEach((fieldName) => {
        if (fieldName.includes(props.type)) {
          updatedValues[fieldName] = replicateValue;
        }
      });
  
      formikRef.current.setValues(updatedValues, false);
    }
  }

  function onChangeReplicateValue(e) {
    setReplicateValue(e.target.value);
  }

  function handleSubmit(searchParams, { setSubmitting }) {
    let params = {
      agentId: 0,
      domesticCarrierMarkupValues: null,
      internationalCarrierMarkupValues: null,
      sotoCarrierMarkupValues: null,
    };

    for (let [key, value] of Object.entries(params)) {
      if (key === props.type) {
        params[key] = props.markupList[key];
        break;
      }
    }

    let id = "";
    let rowNo = "";
    let markupRowNo = "";
    for (let [key, value] of Object.entries(searchParams)) {
      [id, rowNo, markupRowNo] = key.toString().split("__");
      params[id].Markups[rowNo].markUpValues[
        markupRowNo
      ].actualTransactionValue = value;
    }

    props.setIsError(false);
    props.setIsSuccess(false);
    setSubmitting(true);
    props.setIsSaving(true);
    scrollToTop(0);

    WebApi.doUpdateFlightMarkup(
      params,
      function(response) {
        props.setIsError(!response.success);
        props.setIsSuccess(response.success);
        setSubmitting(false);
        props.setIsSaving(false);
        props.setInfoText(
          response.message ? response.message : "saved successfully"
        );
        props.setReloadFlag(true);
      },
      function(error) {
        console.error("Error", error);
        setSubmitting(false);
      }
    );
  }

  useEffect(() => {
    if (replicatingValues) {
      const allUpdated = Object.keys(formikRef.current.values).every((fieldName) => {
        return !fieldName.includes(props.type) ||
          formikRef.current.values[fieldName] === replicateValue;
      });

      if (allUpdated) {
        setReplicatingValues(false);
        setReplicateLabel("Replicate");
      }
    }
  }, [formikRef.current?.values, replicateValue, replicatingValues]);

  return (
    <RootContainer>
      <Formik
        innerRef={formikRef}
        initialValues={props.initialValues}
        onSubmit={handleSubmit}
      >
        {({
          values,
          isSubmitting,
          setFieldValue,
          handleChange,
          initialValues,
        }) => (
          <Form>
            <div className="form-wrapper">
              <div className="form-row">
                <div className="form-element w25p">
                  <ReplicateButton
                    onClick={replicateMarkupValues}
                    label={replicateLabel}
                    onChange={onChangeReplicateValue}
                    value={replicateValue}
                  />
                </div>
                <div className="form-element w25p">
                  {/* <CustomFormSaveButton /> */}
                  <Button
                    className="btn btn-submit"
                    type="submit"
                    disabled={isSubmitting || replicatingValues}
                    label="Save"
                  >
                    <div className="btn-element-wrapper flex-box align-items-center">
                      {isSubmitting ? (
                        <span
                          style={{
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <MdSave /> Saving...
                        </span>
                      ) : (
                        <span
                          style={{
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <MdSave /> Save
                        </span>
                      )}
                      {/* <span className="btn-label">{props.label}</span> */}
                    </div>
                  </Button>
                </div>
              </div>
              <div className="form-row">
                <div className="form-element">
                  <CustomReactTable
                    data={props.data}
                    columns={columns}
                    enableColumnFilters={true}
                    showPagination={false}
                    pageSize={props.data.length}
                  />
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </RootContainer>
  );
};

export default FlightMarkupTable;

const ReplicateButton = (props) => {
  return (
    <div className="replicate-wrapper flex-box align-items-center">
      <input onChange={props.onChange} value={props.value} type="number" />
      <div
        className={cx(
          "btn replicate-button flex-box align-items-center btn-submit",
          props.disabled && "disabled"
        )}
        onClick={props.onClick}
        disabled={props.disabled}
      >
        <MdFileCopy /> <span>{props.label}</span>
      </div>
    </div>
  );
};

const RootContainer = styled.div`
  .form-container-wrapper {
    width: 100%;
    .form-container {
      width: 100%;
      min-height: 101px;
      border-radius: 8px;
      position: relative;

      box-shadow: 2px 2px 10px 0px rgba(133, 131, 133, 1);
      -webkit-box-shadow: 2px 2px 10px 0px rgba(133, 131, 133, 1);
      -moz-box-shadow: 2px 2px 10px 0px rgba(133, 131, 133, 1);
    }
  }

  .form-row {
    display: flex;
    width: 100%;
  }

  .form-element {
    padding: 20px 10px;
    text-align: left;
    width: 100%;
    input {
      outline: none;

      border-radius: 3px;
      width: 60;

      height: 40px;
      text-align: center;
      font-weight: 500;
      &:placeholder {
        font-weight: 500;
        font-size: 14px;
      }
      &:focus {
        outline: none;
      }
    }
    label,
    .text-header {
      font-size: 13px;
      padding: 0 8px;
      width: 100%;
      text-transform: uppercase;
      font-weight: 500;
    }
    select {
      display: block;
      padding: 11px 3px;
      margin-top: 5px;
      border-radius: 3px;
      width: 100%;

      &:focus {
        outline: none;
      }
    }
  }

  .btn-element {
    // padding-top: 45px;
    position: relative;
    padding: 0 10px 10px;
    button {
      padding: 8px 15px 8px 10px;
      text-transform: uppercase;
    }
  }

  .btn-submit {
    padding: 10px 15px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    border: 0px;
    border: 1px solid #ccc;

    transition: ease 0.4s;
    min-height: 40px;
    &:disabled {
      cursor: not-allowed;
    }
    &:hover {
    }
  }

  .replicate-wrapper {
    max-width: 250px;
    box-sizing: border-box;
    gap: 10px;
    height: 30;
    display: flex;

    input {
      text-align: center;
    }

    .replicate-button {
      gap: 5px;
      width: 110px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }

  .w25p {
    width: 25%;
  }

  .w30p {
    width: 33.3%;
  }

  .w50p {
    width: 50%;
  }

  .replicate-wrapper {
    .input-title {
      font-size: 16px;
      font-weight: 500;
    }
  }

  .oa-table-container {
    thead {
      th {
        input {
        }
      }
    }
  }
`;
